import Api from '../api/reconApi.js';
import * as lookups from './lookups';

export function addWorkItemPart(data, errorType) {
	return dispatch => Api.postData('work_item_parts/', data).then(resp => dispatch(lookups.activeVehicleWithPromise(data.vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}

export function addWorkItemPartsBulk(items, vehicle_id, errorType) {
	return async (dispatch) => {
		for (let i = 0; i < items.length; i++) {
			await Api.postData('work_item_parts/', items[i]).catch(ex => Api.handleApiError(ex, errorType));
		}
		return dispatch(lookups.activeVehicleWithPromise(vehicle_id));
	};
}

export function updateWorkItemPart(id, data, errorType) {
	return dispatch => Api.patchData(`work_item_parts/${id}`, data).then(() => dispatch(lookups.activeVehicleWithPromise(data.vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateWorkItemPartRaw(id, data, errorType) {
	return dispatch => Api.patchData(`work_item_parts/${id}`, data).then(() => {}).catch(ex => Api.handleApiError(ex, errorType));
}

export function softDeleteWorkItemPart(id, vehicle_id, errorType) {
	return dispatch => Api.patchData(`work_item_parts/${id}`, { deleted: true, vehicle_id }).then(() => dispatch(lookups.activeVehicleWithPromise(vehicle_id))).catch(ex => Api.handleApiError(ex, errorType));
}
